import React from 'react';
import { HStack, Stack, Text } from '@chakra-ui/react';
import { ReactComponent as Pending } from 'assets/icons/pendingIcon.svg';
import { ReactComponent as Success } from 'assets/icons/successIcon.svg';
import { useCryptoWhiteList } from 'hooks';
import { useTranslation } from 'localization';

import { CopyClipBoard, Spinner } from 'components';

import BorderedBox from '../../../ProfileTab/components/BorderedBox';

const rowBorder = 'rgba(255,255,255,0.06)';
const accountSepBorder = 'rgba(255,255,255,0.08)';

const Whitelist: React.FC = () => {
  const { t } = useTranslation('component.settings.security');
  const { data: whitelist, isLoading } = useCryptoWhiteList({ queries: {} });
  const list = whitelist?.list ?? [];

  const status = (verified: boolean) =>
    verified ? (
      <HStack gap={2} alignItems="center" flexShrink={0}>
        <Text color="primary" fontSize="sm" fontWeight="medium">
          {t('verified')}
        </Text>
        <Success width={22} />
      </HStack>
    ) : (
      <HStack gap={2} alignItems="center" flexShrink={0}>
        <Text color="warning" fontSize="sm" fontWeight="medium">
          {t('pending')}
        </Text>
        <Pending />
      </HStack>
    );

  return (
    <BorderedBox title={t('whitelist')} w="100%">
      {isLoading ? (
        <Stack w="100%" align="center" justify="center" minH="120px">
          <Spinner />
        </Stack>
      ) : list.length === 0 ? (
        <Text fontSize="sm" color="body2" py={2}>
          {t('noWhitelist')}
        </Text>
      ) : (
        <Stack gap={0}>
          {list.map((account, accIndex) => (
            <Stack
              key={account.id}
              gap={0}
              pt={accIndex > 0 ? 4 : 0}
              mt={accIndex > 0 ? 4 : 0}
              borderTopWidth={accIndex > 0 ? '1px' : 0}
              borderTopColor={accountSepBorder}
            >
              <HStack
                w="100%"
                alignItems="flex-start"
                justifyContent="space-between"
                gap={3}
                py={3}
                borderBottomWidth="1px"
                borderBottomColor={rowBorder}
              >
                <Text
                  fontSize="sm"
                  fontWeight="semibold"
                  color="body"
                  wordBreak="break-word"
                >
                  {account.title || '—'}
                </Text>
                {status(account.status === 'VERIFIED')}
              </HStack>
              <Stack
                alignItems={{ base: 'flex-start', md: 'center' }}
                justifyContent="flex-start"
                flexDir={{ base: 'column', md: 'row' }}
                py={3}
                gap={{ base: 2, md: 4 }}
              >
                <Text
                  fontSize="sm"
                  fontWeight="medium"
                  color="body2"
                  pr={{ md: 3 }}
                  minW={{ md: '140px' }}
                  flexShrink={0}
                >
                  {t('walletAddress')}
                </Text>
                <CopyClipBoard
                  initialValue={account.wallet_address}
                  showCharacterLength={24}
                />
              </Stack>
            </Stack>
          ))}
        </Stack>
      )}
    </BorderedBox>
  );
};

export default Whitelist;
